export const iconFontAwesomeHouseholdHouseChimneyWindow = (
	<i className="fa-solid fa-house-chimney-window"></i>
);
